import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import siteConfig from "../config/siteConfig";
import "../css/main.scss";

function Main() {
  useEffect(() => {
    document.title = `${siteConfig.displayName} | Official Store`;
  }, []);

  const editorialProduct =
    productData.find((product) => product.category === "Coats & jackets") || productData[0];
  const categoryStories = [
    ["New denim", "Denim"],
    ["New dresses", "Dresses"],
    ["New shirts", "Tops & blouses"],
  ]
    .map(([title, category]) => [
      title,
      category,
      productData.find((product) => product.category === category)?.images[4],
    ])
    .filter((story) => story[2]);

  return (
    <main className="home-page">
      <section className="home-hero" aria-labelledby="hero-title">
        <picture>
          <source media="(max-width: 768px)" srcSet="/img/generated/home-hero-mobile.jpg" />
          <img
            src="/img/generated/home-hero.jpg"
            alt="Model in a sculptural cobalt dress and red heels"
            fetchpriority="high"
          />
        </picture>
        <h1 id="hero-title" className="sr-only">New collection</h1>
      </section>

      <section className="home-intro" aria-labelledby="new-collection-heading">
        <h2 id="new-collection-heading">New collection</h2>
        <Link to="/shop?sort=new">Shop now</Link>
      </section>

      <Link className="gift-guide" to="/shop?sort=new">
        <img
          src="/img/generated/campaign-color.jpg"
          alt="Vivid fall tailoring and accessories"
          loading="lazy"
        />
        <div className="image-caption">
          <h2>Gift guide</h2>
          <span>Shop now</span>
        </div>
      </Link>

      <section className="editorial-grid" aria-label="Seasonal stories">
        <Link className="editorial-card" to="/shop?category=Coats%20%26%20jackets">
          <img
            src={editorialProduct.image}
            alt={editorialProduct.name}
            loading="lazy"
          />
          <div className="image-caption">
            <h2>Fall in color</h2>
            <span>Shop the edit</span>
          </div>
        </Link>
        <Link className="editorial-card" to="/about">
          <img
            src="/img/generated/product-22-view-06.jpg"
            alt="Two women wearing colorful tailoring in a gallery"
            loading="lazy"
          />
          <div className="image-caption">
            <h2>The Issue No. 1</h2>
            <span>Discover the campaign</span>
          </div>
        </Link>
      </section>

      <section className="category-stories" aria-labelledby="shop-category-title">
        <h2 id="shop-category-title" className="sr-only">Shop by category</h2>
        {categoryStories.map(([title, category, image]) => (
          <Link
            key={title}
            to={`/shop?category=${encodeURIComponent(category)}`}
            className="category-story"
          >
            <img src={image} alt="" loading="lazy" />
            <span>{title}</span>
          </Link>
        ))}
      </section>

      <section className="store-story">
        <img
          src="/img/generated/product-28-view-06.jpg"
          alt="Vappyfurhome accessories editorial"
          loading="lazy"
        />
        <div className="image-caption">
          <h2>Need a little help?</h2>
          <Link to="/contact">Contact us</Link>
        </div>
      </section>
    </main>
  );
}

export default Main;
